export default __webpack_public_path__ + "static/media/img-0305-brazil-full-face.0ee31b96.png";